import { Box, Typography } from '@mui/material';

import { SHRED_COLORS, SHRED_COPY, SHRED_EXPLAINER, SHRED_FONTS } from '../constants';
import { buildRookieRules, buildRules } from '../helpers';
import { Panel, SectionTitle } from './shared';

const Explainer = ({ challenge }) => (
  <Box component="section" aria-labelledby="shred-how-title">
    <SectionTitle kicker="Fair for everyone" title={SHRED_COPY.EXPLAINER_TITLE} id="shred-how-title" />
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
      {SHRED_EXPLAINER.map((item) => (
        <Panel key={item.title} sx={{ p: 2.25 }}>
          <Box aria-hidden="true" sx={{ fontSize: 28 }}>{item.icon}</Box>
          <Typography sx={{ fontFamily: SHRED_FONTS.display, fontWeight: 700, fontSize: 22, textTransform: 'uppercase', mt: 0.5 }}>{item.title}</Typography>
          <Typography sx={{ fontFamily: SHRED_FONTS.body, fontSize: 14, color: SHRED_COLORS.muted, mt: 0.5, lineHeight: 1.5 }}>{item.body}</Typography>
        </Panel>
      ))}
    </Box>
    <Panel sx={{ p: 2.5, mt: 2 }}>
      <Typography sx={{ fontFamily: SHRED_FONTS.numeric, fontSize: 12, letterSpacing: '0.18em', color: SHRED_COLORS.muted }}>
        EXAMPLE
      </Typography>
      <Typography sx={{ fontFamily: SHRED_FONTS.body, fontSize: 15, mt: 0.5 }}>
        Baseline 40,000 work per session. Contest average 46,000. That is <b style={{ color: SHRED_COLORS.positive }}>+15%</b>, the same score as a
        member who went from 80,000 to 92,000.
      </Typography>
    </Panel>
    <Typography component="h3" sx={{ mt: 4, mb: 1.5, fontFamily: SHRED_FONTS.display, fontWeight: 800, fontSize: 28, textTransform: 'uppercase' }}>
      {SHRED_COPY.RULES_TITLE}
    </Typography>
    <Box component="ol" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.75, color: SHRED_COLORS.muted, fontFamily: SHRED_FONTS.body, fontSize: 14, lineHeight: 1.5 }}>
      {buildRules(challenge).map((rule) => (
        <li key={rule}>{rule}</li>
      ))}
    </Box>
    <Typography component="h3" sx={{ mt: 4, mb: 1.5, fontFamily: SHRED_FONTS.display, fontWeight: 800, fontSize: 28, textTransform: 'uppercase' }}>
      {SHRED_COPY.ROOKIE_RULES_TITLE}
    </Typography>
    <Box component="ol" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.75, color: SHRED_COLORS.muted, fontFamily: SHRED_FONTS.body, fontSize: 14, lineHeight: 1.5 }}>
      {buildRookieRules(challenge).map((rule) => (
        <li key={rule}>{rule}</li>
      ))}
    </Box>
  </Box>
);

export default Explainer;
